import httpOption from "./httpOption";
import AppSettings from "../appsettings";

export const apiBaseUrl = () =>
  `${AppSettings.hostUrl}:${AppSettings.apiPort}${AppSettings.apiPath}`;

export const apiUrl = (path = "") => `${apiBaseUrl()}${path}`;

// Checks status rather than `ok` because test doubles only stub `status`.
export const isSuccess = (response) =>
  response.status >= 200 && response.status < 300;

const encodeBody = (body) =>
  typeof body === "string" || body instanceof FormData
    ? body
    : JSON.stringify(body);

// `option` is an httpOption key (GET, GET_NO_LANGUAGE, POST, POSTFILE, PUT,
// PATCH, DELETE). Pass `body` as an object (JSON-encoded), string or FormData.
export function apiFetch(url, { option = "GET", body } = {}) {
  const options = httpOption[option]();
  if (body !== undefined) {
    options.body = encodeBody(body);
  }
  return fetch(url, options);
}

// Resolves the parsed JSON of a 2xx response and rejects with the raw Response
// otherwise. Callers and isAuthError (src/queryClient.js) read its `status`.
export async function apiJson(url, request) {
  const response = await apiFetch(url, request);
  if (isSuccess(response)) {
    return response.json();
  }
  throw response;
}
